/**
 * Author：brand
 * Creation Time：2019-06-04 18:15
 * Email：brandhuang@qq.com
 */
import ax from '../../axios'

/**
 * 通知中心相关    ⬇
 * @param params
 * @returns {*}
 */
export function noticeAPI (params) {
  return ax({
    url: '/wlapi/updateLog/getUpdateLog',
    method: 'GET',
    params
  })
}
export function noticeDetailAPI (params) {
  return ax({
    url: '/wlapi/updateLog/getUpLogByNum',
    method: 'POST',
    params
  })
}
// 标记系统消息已读未读
export function setLogIsRead (params) {
  return ax({
    url: '/wlapi/updateLog/setLogIsRead',
    method: 'POST',
    params
  })
}
// 公司公告列表
export function companyNoticeListAPI (params) {
  return ax({
    url: '/wlapi/announcement/selectAnnouncement',
    method: 'POST',
    params
  })
}
// 公司公告新增和编辑 公告id, 非必传, 传了是修改, 不传是新增
export function companyNoticeAddAPI (params) {
  return ax({
    url: '/wlapi/announcement/saveAnnouncement',
    method: 'POST',
    params
  })
}
// 公司公告删除 数组
export function companyNoticeDeleteAPI (params) {
  return ax({
    url: '/wlapi/announcement/deleteAnnouncement',
    method: 'POST',
    params
  })
}

/**
 * 个人信息相关
 * @param params
 * @returns {*}
 */
export function editAvatarAPI (params) {
  return ax({
    url: '/wlapi/sysSetting/editHeadimg',
    method: 'POST',
    data:params
  })
}
export function resetAvatarAPI (params) {
  return ax({
    url: '/wlapi/sysSetting/defaultHeadimg',
    method: 'get',
    data:params
  })
}
export function changePasswordAPI (params) {
  return ax({
    url: '/wlapi/setting/editPassword',
    method: 'get',
    params
  })
}
export function getProfileAPI (params) {
  return ax({
    url: '/wlapi/setting/profile',
    method: 'get',
    params
  })
}

export function saveChangeProfileAPI (params) {
  return ax({
    url: '/wlapi/sysSetting/editRealNameNo',
    method: 'get',
    params
  })
}

export function visitorFieldDisplayConfig (params) {
  return ax({
    url: '/wlapi/setting/visitorFieldDisplayConfig',
    method: 'post',
    params
  })
}

export function delVisitorField (params) {
  return ax({
    url: '/wlapi/setting/delVisitorField',
    method: 'post',
    params
  })
}

export function editVisitorField (params) {
  return ax({
    url: '/wlapi/setting/editVisitorField',
    method: 'post',
    params
  })
}

export function addVisitorField (params) {
  return ax({
    url: '/wlapi/setting/addVisitorField',
    method: 'post',
    params
  })
}
export function shopConfig (params) {
  return ax({
    url: '/wlapi/automsgsetting/getMallSet',
    method: 'post',
    params
  })
}

/**
 * 个人信息排序
 * @param params
 * @returns {AxiosPromise}
 */
export function userInfoSort (params) {
  return ax({
    url: '/wlapi/setting/saveVisitorSorts',
    method: 'post',
    data: params
  })
}
